import Resizer from "react-image-file-resizer";

// Helper function to get image dimensions from a File or Blob
export const getImageDimensions = (
  file: File
): Promise<{ width: number; height: number }> => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      resolve({ width: img.width, height: img.height });
    };
    img.src = URL.createObjectURL(file);
  });
};

// Helper function to get dimensions from base64
export const getBase64Dimensions = (
  base64: string
): Promise<{ width: number; height: number }> => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      resolve({ width: img.width, height: img.height });
    };
    img.src = base64;
  });
};

export const resizeFile = (file: File): Promise<string> => {
  return new Promise((resolve) => {
    // Log original file details

    Resizer.imageFileResizer(
      file,
      300, // Max width
      400, // Max height
      "JPEG", // Output format
      90, // Quality (reduced from 100 for better compression)
      0, // Rotation
      (uri) => {
        
        resolve(uri as string);
      },
      "base64", // Output type
      300, // Min width
      400 // Min height
    );
  });
};
